import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from './../../shared/api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { saveAs } from 'file-saver';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { UserService } from './../../@core/data/users.service';
import { ConfirmationService } from 'primeng/api';
import { debounceTime } from 'rxjs/operators';



@Component({
  selector: 'educational',
  templateUrl: "./educationalformWithoutCgpa.component.html",
  providers: [ConfirmationService]
})
export class EducationalFormWithoutCgpaComponent implements OnInit {
  FeedbackForm: FormGroup;
  public filterInput = new FormControl();
  public filterInput2 = new FormControl();
  public filterInput3 = new FormControl();
  public filterInput4 = new FormControl();
  public filterInput5 = new FormControl();
  public filterInput6 = new FormControl();
  public filterInput7 = new FormControl();
  public filterInput8 = new FormControl();
  public filterInput9 = new FormControl();
  public filterInput10 = new FormControl();
  public filterInput11 = new FormControl();
  public filterInput12 = new FormControl();
  @Input() user_id: any;
  @Input() edu_id: any;
  @Input() amount_paid: string;
  @Input() admin_show: string;
  @Input() autoName: string;
  @Input() yearValue = [];
  @Input() course_name_auto: string;
  @Input() college_year_auto: string;
  // @Input() courseShortName: string;

  validations_flag = false;
  feedback_message;
  showExperience = false;
  totalMarks: number;
  totalMarksOut: number;
  formData: FormGroup;
  edu_form: FormGroup;
  years_array;
  courseValidation = true;
  collegeYearValidation = true;
  classValidation = true;
  monthValidation = true;
  yearValidation = true;
  attemptValidation = true;
  instructionValidation = true;
  edu_data;
  course_data;
  user: any;
  hourValue: any;
  hourValue8: any;
  hourValue7: any;
  hourValue6: any;
  hourValue5: any;
  hourValue4: any;
  hourValue3: any;
  hourValue2: any;
  hourValue9: any;
  hourValue10: any;
  hourValue11: any;
  hourValue12: any;
  lecVal1: any;
  lecVal2: any;
  lecVal3: any;
  lecVal4: any;
  lecVal5: any;
  lecVal6: any;
  lecVal7: any;
  lecVal8: any;
  lecVal9: any;
  lecVal10: any;
  lecVal11: any;
  lecVal12: any;
  getcxg1: number;
  getcxg2: number;
  getcxg3: number;
  getcxg4: number;
  getcxg5: number;
  getcxg6: number;
  getcxg7: number;
  getcxg8: number;
  getcxg9: number;
  getcxg10: number;
  getcxg11: number;
  getcxg12: number;
  getoutoff1: number;
  getoutoff2: number;
  getoutoff3: number;
  getoutoff4: number;
  getoutoff5: number;
  getoutoff6: number;
  getoutoff7: number;
  getoutoff8: number;
  getoutoff9: number;
  getoutoff10: number;
  getoutoff11: number;
  getoutoff12: number;
  semesterValidation = true;
  subjectName: any;
  withoutCodeSub: any;
  subjectName2: any;
  withoutCodeSub2: any;
  withoutCodeSub3: any;
  subjectName3: any;
  subjectName4: any;
  withoutCodeSub4: any;
  subjectName5: any;
  withoutCodeSub5: any;
  subjectName6: any;
  withoutCodeSub6: any;
  subjectName7: any;
  withoutCodeSub7: any;
  subjectName8: any;
  withoutCodeSub8: any;
  subjectName9: any;
  withoutCodeSub9: any;
  subjectName10: any;
  withoutCodeSub10: any;
  subjectName11: any;
  withoutCodeSub11: any;
  subjectName12: any;
  withoutCodeSub12: any;
  course_code1: any;
  course_code8: any;
  course_code2: any;
  course_code3: any;
  course_code4: any;
  course_code5: any;
  course_code6: any;
  course_code7: any;
  course_code9: any;
  course_code10: any;
  course_code11: any;
  course_code12: any;
  prac_hour1: any;
  prac_hour2: any;
  prac_hour3: any;
  prac_hour4: any;
  prac_hour5: any;
  prac_hour6: any;
  prac_hour7: any;
  prac_hour8: any;
  prac_hour9: any;
  prac_hour10: any;
  prac_hour11: any;
  prac_hour12: any;
  lec_per_week1: string;
  lec_per_week2: string;
  lec_per_week3: string;
  lec_per_week4: string;
  lec_per_week5: string;
  lec_per_week6: string;
  lec_per_week7: string;
  lec_per_week8: string;
  lec_per_week9: string;
  lec_per_week10: string;
  lec_per_week11: string;
  lec_per_week12: string;
  public filterText: any;
  public filterText2: any;
  filterText3: any
  public filterText4: any;
  public filterText5: any;
  public filterText6: any;
  public filterText7: any;
  public filterText8: any;
  public filterText9: any;
  public filterText10: any;
  public filterText11: any;
  public filterText12: any;
  autocheck = true;
  showcodeDropdown1: boolean = true;
  showcodeDropdown2: boolean = true;
  showcodeDropdown3: boolean = true;
  showcodeDropdown4: boolean = true;
  showcodeDropdown5: boolean = true;
  showcodeDropdown6: boolean = true;
  showcodeDropdown7: boolean = true;
  showcodeDropdown8: boolean = true;
  showcodeDropdown9: boolean = true;
  showcodeDropdown10: boolean = true;
  showcodeDropdown11: boolean = true;
  showcodeDropdown12: boolean = true;

  isLoadingResults: boolean = false;
  newcourse_code = [];
  course_name;
  college_year;
  edu_level;
  semester_auto;
  isDisabled = false;

  constructor(protected api: ApiService,
    private router: Router,
    private userService: UserService,
    private route: ActivatedRoute,
    public toasterService: NbToastrService,
    private formBuilder: FormBuilder,
    private confirmationService: ConfirmationService,
    protected ref: NbDialogRef<EducationalFormWithoutCgpaComponent>) { }

  async ngOnInit() {
    if (this.admin_show == "true") {
      this.isDisabled = false;
    } else {
      //this.edu_form.controls['lecturehourFirstCtrl'].disable();

      this.isDisabled = !this.isDisabled;
    }

    // this.userService.onUserChange()
    // .subscribe((user: any) => this.user = user);
    // if(this.user.role == 'admin'){
    //   this.admin_show = false;
    // }

    // Initialize formData
    this.formData = this.formBuilder.group({
      courseCode: [''], // Example control for course code
    });

    this.edu_form = this.formBuilder.group({
      courseNameCtrl: ['', Validators.required],
      collegeYearCtrl: ['', Validators.required],
      semesterCtrl: ['', Validators.required],
      overallclassCtrl: ['', Validators.required],
      monthCtrl: ['', Validators.required],
      yearCtrl: ['', Validators.required],
      overmarksobtCtrl: ['', Validators.required],
      overmarksoutCtrl: ['', Validators.required],
      subjectFirstCtrl: [''],
      markFirstCtrl: ['', Validators.required],
      markFirstOutCtrl: ['', Validators.required],
      subjectSecondCtrl: [''],
      markSecondCtrl: [''],
      markSecondOutCtrl: [''],
      subjectThirdCtrl: [''],
      markThirdCtrl: [''],
      markThirdOutCtrl: [''],
      subjectFourthCtrl: [''],
      markFourthCtrl: [''],
      markFourthOutCtrl: [''],
      subjectFifthCtrl: [''],
      markFifthCtrl: [''],
      markFifthOutCtrl: [''],
      subjectSixthCtrl: [''],
      markSixthCtrl: [''],
      markSixthOutCtrl: [''],
      subjectSeventhCtrl: [''],
      markSeventhCtrl: [''],
      markSeventhOutCtrl: [''],
      subjectEighthCtrl: [''],
      markEighthCtrl: [''],
      markEighthOutCtrl: [''],
      subjectNinthCtrl: [''],
      markNinthCtrl: [''],
      markNinthOutCtrl: [''],
      subjectTenthCtrl: [''],
      markTenthCtrl: [''],
      markTenthOutCtrl: [''],
      subjectElevanthCtrl: [''],
      markElevanthCtrl: [''],
      markElevanthOutCtrl: [''],
      subjectTwelfthCtrl: [''],
      markTwelfthCtrl: [''],
      markTwelfthOutCtrl: [''],
      instructionCtrl: ['', Validators.required],
      lecturehourFirstCtrl: [''],
      lecturehourSecondCtrl: [''],
      lecturehourThirdCtrl: [''],
      lecturehourFourthCtrl: [''],
      lecturehourFifthCtrl: [''],
      lecturehourSixCtrl: [''],
      lecturehourSeventhCtrl: [''],
      lecturehourEighthCtrl: [''],
      lecturehourNinthCtrl: [''],
      lecturehourTenthCtrl: [''],
      lecturehourElevanthCtrl: [''],
      lecturehourTwelfthCtrl: [''],
      practicalhourFirstCtrl: [''],
      practicalhourSecondCtrl: [''],
      practicalhourThirdCtrl: [''],
      practicalhourFourthCtrl: [''],
      practicalhourFifthCtrl: [''],
      practicalhourSixCtrl: [''],
      practicalhourSeventhCtrl: [''],
      practicalhourEighthCtrl: [''],
      practicalhourNinthCtrl: [''],
      practicalhourTenthCtrl: [''],
      practicalhourElevanthCtrl: [''],
      practicalhourTwelfthCtrl: [''],
      specialInstrctionCtrl: [''],
      totalweeksCtrl: [''],
      gradecreditsFirstCtrl: ['', Validators.required],
      gradecreditsSecondCtrl: [''],
      gradecreditsThirdCtrl: [''],
      gradecreditsFourthCtrl: [''],
      gradecreditsFifthCtrl: [''],
      gradecreditsSixthCtrl: [''],
      gradecreditsSeventhCtrl: [''],
      gradecreditsEighthCtrl: [''],
      gradecreditsNinthCtrl: [''],
      gradecreditsTenthCtrl: [''],
      gradecreditsElevanthCtrl: [''],
      gradecreditsTwelfthCtrl: [''],
      externalOutOfCtrl: ['', Validators.required],
      internalOutOfCtrl: ['', Validators.required],
      totalOutOfCtrl: ['', Validators.required],
      externalOut2OfCtrl: [''],
      internalOut2OfCtrl: [''],
      totalOut2OfCtrl: [''],
      externalOut3OfCtrl: [''],
      internalOut3OfCtrl: [''],
      totalOut3OfCtrl: [''],
      externalOut4OfCtrl: [''],
      internalOut4OfCtrl: [''],
      totalOut4OfCtrl: [''],
      externalOut5OfCtrl: [''],
      internalOut5OfCtrl: [''],
      totalOut5OfCtrl: [''],
      externalOut6OfCtrl: [''],
      internalOut6OfCtrl: [''],
      totalOut6OfCtrl: [''],
      externalOut7OfCtrl: [''],
      internalOut7OfCtrl: [''],
      totalOut7OfCtrl: [''],
      externalOut8OfCtrl: [''],
      internalOut8OfCtrl: [''],
      totalOut8OfCtrl: [''],
      externalOut9OfCtrl: [''],
      internalOut9OfCtrl: [''],
      totalOut9OfCtrl: [''],
      externalOut10ofCtrl: [''],
      internalOut10ofCtrl: [''],
      totalOut10ofCtrl: [''],
      externalOut11ofCtrl: [''],
      internalOut11ofCtrl: [''],
      totalOut11ofCtrl: [''],
      externalOut12ofCtrl: [''],
      internalOut12ofCtrl: [''],
      totalOut12ofCtrl: [''],
    })


    if (this.college_year_auto == 'SemesterOne' || this.college_year_auto == 'SemesterTwo') {
      this.college_year = 'First';
      if (this.college_year_auto == 'SemesterOne') {
        this.semester_auto = 'I';
      } else {
        this.semester_auto = 'II';
      }
    } else if (this.college_year_auto == 'SemesterThree' || this.college_year_auto == 'SemesterFour') {
      this.college_year = 'Second';
      if (this.college_year_auto == 'SemesterThree') {
        this.semester_auto = 'III';
      } else {
        this.semester_auto = 'IV';
      }
    } else if (this.college_year_auto == 'SemesterFive' || this.college_year_auto == 'SemesterSix') {
      this.college_year = 'Third';
      if (this.college_year_auto == 'SemesterFive') {
        this.semester_auto = 'V';
      } else {
        this.semester_auto = 'VI';
      }
    }

    const now = new Date().getUTCFullYear();
    this.years_array = Array(now - (now - 50)).fill('').map((v, idx) => now - idx);

    // Fetch courses data
    this.api.getCouses().subscribe((data: any) => {
      if (data.status === 200) {
        this.course_data = data.data;

        // Check if course_name_auto is available and find the corresponding course
        if (this.course_name_auto) {
          const course = this.course_data.find(
            (element) =>
              element.CourseName === this.course_name_auto ||
              element.CourseShortForm === this.course_name_auto
          );
          if (course) {
            this.course_name = course.CourseShortForm;
            this.edu_level = course.type;
          }
        }
      }

      // Consolidated API call for fetching course codes
      this.isLoadingResults = true;
      this.api.getCouseCode(this.course_name, this.semester_auto).subscribe((data: any) => {
        if (data.status === 200) {
          this.autocheck = false;

          // Dynamic handling of filter inputs and course codes
          const filterInputs = [
            this.filterInput, this.filterInput2, this.filterInput3, this.filterInput4,
            this.filterInput5, this.filterInput6, this.filterInput7, this.filterInput8,
            this.filterInput9, this.filterInput10
          ];

          filterInputs.forEach((filterInput, index) => {
            this[`filterText${index + 1}`] = '';
            this[`course_code${index + 1}`] = data.data;

            filterInput.valueChanges.pipe(debounceTime(200)).subscribe((term) => {
              this[`filterText${index + 1}`] = term;
            });
          });

          this.isLoadingResults = false;
        }
      });
    });

    // Fetch education data if user_id and edu_id are available
    if (this.user_id && this.edu_id) {
      this.isLoadingResults = true;
      this.api.getEducation(this.edu_id, this.user_id).subscribe((data: any) => {
        if (data.status === 200) {
          this.edu_data = data.data;
          this.course_name = this.edu_data.CourseName;
          this.college_year = this.edu_data.CollegeYear;
          this.semester_auto = this.edu_data.Semester;

          // Dynamically manage subject dropdowns
          for (let i = 1; i <= 9; i++) {
            const subjectKey = `Subject_${['First', 'Second', 'Third', 'Fourth', 'Fifth', 'Six', 'Seventh', 'Eighth', 'Ninth'][i - 1]}`;
            this[`showcodeDropdown${i}`] = !this.edu_data[subjectKey];
          }
          this.isLoadingResults = false;
        }
      });
    }

  }

  getCourse(value) {

    //this.filterText = "";
    this.subjectName = value
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science') {

      if (value.prac == 'yes') {

        this.prac_hour1 = value.Lec_per_Week
        this.lec_per_week1 = '-'
      } else {
        this.lec_per_week1 = value.Lec_per_Week
        this.prac_hour1 = '-'

      }
    } else {
      this.lec_per_week1 = value.Lec_per_Week
      this.prac_hour1 = ''
    }
    var count = 0
    this.newcourse_code = [];
    this.course_code1.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id']) {

      } else {

        this.newcourse_code.push(element)


      }

      if (count == this.course_code1.length) {
        this.course_code1 = this.newcourse_code
      }
    })
    //this.filterPlaceholder = "Search";
    // this.adminApi.getAllCourse(value).subscribe((data)=>{
    //   this.courses = data['data'];
    // })
    // this.filterInput
    //   .valueChanges
    //   .debounceTime(200)
    //   .subscribe(term => {
    //   this.filterText = term;
    // });
  }

  getSubject(event: any) {

    this.withoutCodeSub = event.target.value
    if (this.subjectName) {

    } else {

    }
  }

  getCourse2(value) {

    //this.filterText = "";
    this.subjectName2 = value
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science') {
      if (value.prac == 'yes') {

        this.prac_hour2 = value.Lec_per_Week
        this.lec_per_week2 = '-'
      } else {
        this.lec_per_week2 = value.Lec_per_Week
        this.prac_hour2 = '-'

      }
    } else {
      this.lec_per_week2 = value.Lec_per_Week
      this.prac_hour2 = ' '
    }

    var count = 0
    this.newcourse_code = [];
    this.course_code3.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id']) {

      } else {

        this.newcourse_code.push(element)


      }

      if (count == this.course_code3.length) {
        this.course_code3 = [];
        this.course_code3 = this.newcourse_code
      }
    })
  }

  getSubject2(event: any) {

    this.withoutCodeSub2 = event.target.value

  }

  getCourse3(value) {
    this.subjectName3 = value
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science') {
      if (value.prac == 'yes') {

        this.prac_hour3 = value.Lec_per_Week
        this.lec_per_week3 = '-'
      } else {
        this.lec_per_week3 = value.Lec_per_Week
        this.prac_hour3 = '-'

      }
    } else {
      this.lec_per_week3 = value.Lec_per_Week
      this.prac_hour3 = '-'
    }

    var count = 0
    this.newcourse_code = [];
    this.course_code4.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id']) {

      } else {

        this.newcourse_code.push(element)


      }

      if (count == this.course_code4.length) {
        this.course_code4 = [];
        this.course_code4 = this.newcourse_code
      }
    })
  }

  getSubject3(event: any) {
    this.withoutCodeSub3 = event.target.value
  }

  getCourse4(value) {

    this.subjectName4 = value
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science') {
      if (value.prac == 'yes') {

        this.prac_hour4 = value.Lec_per_Week
        this.lec_per_week4 = '-'
      } else {
        this.lec_per_week4 = value.Lec_per_Week
        this.prac_hour4 = '-'

      }
    } else {
      this.lec_per_week4 = value.Lec_per_Week
      this.prac_hour4 = '-'
    }

    var count = 0
    this.newcourse_code = [];
    this.course_code5.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id'] || element['id'] == this.subjectName4['id']) {

      } else {

        this.newcourse_code.push(element)


      }

      if (count == this.course_code5.length) {
        this.course_code5 = [];
        this.course_code5 = this.newcourse_code
      }
    })
  }

  getSubject4(event: any) {

    this.withoutCodeSub4 = event.target.value

  }

  getCourse5(value) {

    this.subjectName5 = value
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science') {
      if (value.prac == 'yes') {

        this.prac_hour5 = value.Lec_per_Week
        this.lec_per_week5 = '-'
      } else {
        this.lec_per_week5 = value.Lec_per_Week
        this.prac_hour5 = '-'

      }
    } else {
      this.lec_per_week5 = value.Lec_per_Week
      this.prac_hour5 = '-'
    }

    var count = 0
    this.newcourse_code = [];
    this.course_code6.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id'] || element['id'] == this.subjectName4['id'] || element['id'] == this.subjectName5['id']) {

      } else {

        this.newcourse_code.push(element)


      }

      if (count == this.course_code6.length) {
        this.course_code6 = [];
        this.course_code6 = this.newcourse_code
      }
    })
  }

  getSubject5(event: any) {

    this.withoutCodeSub5 = event.target.value

  }

  getCourse6(value) {

    this.subjectName6 = value
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science') {
      if (value.prac == 'yes') {

        this.prac_hour6 = value.Lec_per_Week
        this.lec_per_week6 = '-'
      } else {
        this.lec_per_week6 = value.Lec_per_Week
        this.prac_hour6 = '-'

      }
    } else {
      this.lec_per_week6 = value.Lec_per_Week
      this.prac_hour6 = ''
    }
    var count = 0
    this.newcourse_code = [];
    this.course_code7.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id'] || element['id'] == this.subjectName4['id'] || element['id'] == this.subjectName5['id'] || element['id'] == this.subjectName6['id']) {

      } else {

        this.newcourse_code.push(element)


      }

      if (count == this.course_code7.length) {
        this.course_code7 = [];
        this.course_code7 = this.newcourse_code
      }
    })
  }

  getSubject6(event: any) {

    this.withoutCodeSub6 = event.target.value

  }

  getCourse7(value) {

    this.subjectName7 = value
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science') {
      if (value.prac == 'yes') {

        this.prac_hour7 = value.Lec_per_Week
        this.lec_per_week7 = '-'
      } else {
        this.lec_per_week7 = value.Lec_per_Week
        this.prac_hour7 = '-'

      }
    } else {
      this.lec_per_week7 = value.Lec_per_Week
      this.prac_hour7 = '-'
    }
    var count = 0
    this.newcourse_code = [];
    this.course_code8.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id'] || element['id'] == this.subjectName4['id'] || element['id'] == this.subjectName5['id'] || element['id'] == this.subjectName6['id'] || element['id'] == this.subjectName7['id']) {

      } else {

        this.newcourse_code.push(element)


      }

      if (count == this.course_code8.length) {
        this.course_code8 = [];
        this.course_code8 = this.newcourse_code
      }
    })
  }

  getSubject7(event: any) {

    this.withoutCodeSub7 = event.target.value

  }
  getSubject8(event: any) {

    this.withoutCodeSub8 = event.target.value

  }
  getCourse8(value) {

    this.subjectName8 = value
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science') {
      if (value.prac == 'yes') {

        this.prac_hour8 = value.Lec_per_Week
        this.lec_per_week8 = '-'
      } else {
        this.lec_per_week8 = value.Lec_per_Week
        this.prac_hour8 = '-'

      }
    } else {

      this.lec_per_week8 = value.Lec_per_Week
      this.prac_hour8 = '-'
    }
    var count = 0
    this.newcourse_code = [];
    this.course_code9.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id'] || element['id'] == this.subjectName4['id'] || element['id'] == this.subjectName5['id'] || element['id'] == this.subjectName6['id'] || element['id'] == this.subjectName7['id'] || element['id'] == this.subjectName8['id']) {

      } else {

        this.newcourse_code.push(element)


      }

      if (count == this.course_code9.length) {
        this.course_code9 = [];
        this.course_code9 = this.newcourse_code
      }
    })


  }
  getSubject9(event: any) {

    this.withoutCodeSub9 = event.target.value

  }
  getCourse9(value) {

    this.subjectName9 = value
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science') {
      if (value.prac == 'yes') {

        this.prac_hour9 = value.Lec_per_Week
        this.lec_per_week9 = '-'
      } else {
        this.lec_per_week9 = value.Lec_per_Week
        this.prac_hour9 = '-'

      }
    } else {
      this.lec_per_week9 = value.Lec_per_Week
      this.prac_hour9 = '-'
    }
  }

  getCourse10(value) {

    this.subjectName10 = value
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science') {
      if (value.prac == 'yes') {

        this.prac_hour10 = value.Lec_per_Week
        this.lec_per_week10 = '-'
      } else {
        this.lec_per_week10 = value.Lec_per_Week
        this.prac_hour10 = '-'

      }
    } else {
      this.lec_per_week10 = value.Lec_per_Week
      this.prac_hour10 = '-'
    }
  }

  getSubject10(event: any) {

    this.withoutCodeSub10 = event.target.value

  }

  getCourse11(value) {

    this.subjectName11 = value
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science') {
      if (value.prac == 'yes') {

        this.prac_hour11 = value.Lec_per_Week
        this.lec_per_week11 = '-'
      } else {
        this.lec_per_week11 = value.Lec_per_Week
        this.prac_hour11 = '-'

      }
    } else {
      this.lec_per_week11 = value.Lec_per_Week
      this.prac_hour11 = '-'
    }
  }

  getSubject11(event: any) {

    this.withoutCodeSub11 = event.target.value

  }

  getCourse12(value) {

    this.subjectName12 = value
    if (this.course_name_auto == 'B.Sc.' || this.course_name_auto == 'Bachelor of Science' || this.course_name_auto == 'M.Sc.' || this.course_name_auto == 'Master of Science') {
      if (value.prac == 'yes') {

        this.prac_hour12 = value.Lec_per_Week
        this.lec_per_week12 = '-'
      } else {
        this.lec_per_week12 = value.Lec_per_Week
        this.prac_hour12 = '-'

      }
    } else {
      this.lec_per_week12 = value.Lec_per_Week
      this.prac_hour12 = '-'
    }
  }

  getSubject12(event: any) {

    this.withoutCodeSub12 = event.target.value

  }

  saveEdu() {
    this.courseValidation = true;
    this.collegeYearValidation = true;
    this.classValidation = true;
    this.monthValidation = true;
    this.yearValidation = true;
    this.attemptValidation = true;
    this.instructionValidation = true;
    this.semesterValidation = true;

    if (this.edu_form.valid == false) {
      this.edu_form.controls.courseNameCtrl.markAsDirty();
      this.edu_form.controls.overmarksoutCtrl.markAsDirty();
      this.edu_form.controls.overmarksobtCtrl.markAsDirty();
      //this.edu_form.controls.subjectFirstCtrl.markAsDirty();
      this.edu_form.controls.markFirstCtrl.markAsDirty();
      this.edu_form.controls.markFirstOutCtrl.markAsDirty();
      this.edu_form.controls.externalOutOfCtrl.markAsDirty();
      this.edu_form.controls.internalOutOfCtrl.markAsDirty();
      this.edu_form.controls.markFirstOutCtrl.markAsDirty();
      // this.edu_form.controls.subjectSecondCtrl.markAsDirty();
      // this.edu_form.controls.markSecondCtrl.markAsDirty();
      // this.edu_form.controls.markSecondOutCtrl.markAsDirty();
      // this.edu_form.controls.subjectThirdCtrl.markAsDirty();
      // this.edu_form.controls.markThirdCtrl.markAsDirty();
      // this.edu_form.controls.markThirdOutCtrl.markAsDirty();
      // this.edu_form.controls.subjectFourthCtrl.markAsDirty();
      // this.edu_form.controls.markFourthCtrl.markAsDirty();
      // this.edu_form.controls.markFourthOutCtrl.markAsDirty();
      this.edu_form.controls.instructionCtrl.markAsDirty();

      if (this.edu_form.controls.instructionCtrl.value === null || this.edu_form.controls.instructionCtrl.value === '' || this.edu_form.controls.instructionCtrl.value === undefined) {
        this.instructionValidation = false;
      } else {
        this.instructionValidation = true;
      }

      if (this.edu_form.controls.courseNameCtrl.value === null || this.edu_form.controls.courseNameCtrl.value === '' || this.edu_form.controls.courseNameCtrl.value === undefined) {
        this.courseValidation = false;
      } else {
        this.courseValidation = true;
      }

      if (this.edu_form.controls.semesterCtrl.value === null || this.edu_form.controls.semesterCtrl.value === '' || this.edu_form.controls.semesterCtrl.value === undefined) {
        this.semesterValidation = false;
      } else {
        this.semesterValidation = true;
      }

      if (this.edu_form.controls.collegeYearCtrl.value === null || this.edu_form.controls.collegeYearCtrl.value === '' || this.edu_form.controls.collegeYearCtrl.value === undefined) {
        this.collegeYearValidation = false;
      } else {
        this.collegeYearValidation = true;
      }

      if (this.edu_form.controls.overallclassCtrl.value === null || this.edu_form.controls.overallclassCtrl.value === '' || this.edu_form.controls.overallclassCtrl.value === undefined) {
        this.classValidation = false;
      } else {
        this.classValidation = true;
      }

      if (this.edu_form.controls.monthCtrl.value === null || this.edu_form.controls.monthCtrl.value === '' || this.edu_form.controls.monthCtrl.value === undefined) {
        this.monthValidation = false;
      } else {
        this.monthValidation = true;
      }

      if (this.edu_form.controls.yearCtrl.value === null || this.edu_form.controls.yearCtrl.value === '' || this.edu_form.controls.yearCtrl.value === undefined) {
        this.yearValidation = false;
      } else {
        this.yearValidation = true;
      }
    } else {
      var edu_data = {
        courseName: this.edu_form.controls.courseNameCtrl.value,
        collegeYear: this.edu_form.controls.collegeYearCtrl.value,
        semester: this.edu_form.controls.semesterCtrl.value,
        overall_class: this.edu_form.controls.overallclassCtrl.value,
        month: this.edu_form.controls.monthCtrl.value,
        year: this.edu_form.controls.yearCtrl.value,
        overall_marks_obt: this.edu_form.controls.overmarksobtCtrl.value,
        overall_marks_out: this.edu_form.controls.overmarksoutCtrl.value,
        subjectFirst: this.subjectName ? this.subjectName['Course_Subject_name'] : this.withoutCodeSub,
        marks_obt_First: this.edu_form.controls.markFirstCtrl.value,
        marks_out_First: this.edu_form.controls.markFirstOutCtrl.value,
        subjectSecond: this.subjectName2 ? this.subjectName2['Course_Subject_name'] : this.withoutCodeSub2,
        marks_obt_Second: this.edu_form.controls.markSecondCtrl.value,
        marks_out_Second: this.edu_form.controls.markSecondOutCtrl.value,
        subjectThird: this.subjectName3 ? this.subjectName3['Course_Subject_name'] : this.withoutCodeSub3,
        marks_obt_Third: this.edu_form.controls.markThirdCtrl.value,
        marks_out_Third: this.edu_form.controls.markThirdOutCtrl.value,
        subjectFourth: this.subjectName4 ? this.subjectName4['Course_Subject_name'] : this.withoutCodeSub4,
        marks_obt_Fourth: this.edu_form.controls.markFourthCtrl.value,
        marks_out_Fourth: this.edu_form.controls.markFourthOutCtrl.value,
        subjectFifth: this.subjectName5 ? this.subjectName5['Course_Subject_name'] : this.withoutCodeSub5,
        marks_obt_Fifth: this.edu_form.controls.markFifthCtrl.value,
        marks_out_Fifth: this.edu_form.controls.markFifthOutCtrl.value,
        subjectSixth: this.subjectName6 ? this.subjectName6['Course_Subject_name'] : this.withoutCodeSub6,
        marks_obt_Six: this.edu_form.controls.markSixthCtrl.value,
        marks_out_Six: this.edu_form.controls.markSixthOutCtrl.value,
        subjectSeventh: this.subjectName7 ? this.subjectName7['Course_Subject_name'] : this.withoutCodeSub7,
        marks_obt_Seventh: this.edu_form.controls.markSeventhCtrl.value,
        marks_out_Seventh: this.edu_form.controls.markSeventhOutCtrl.value,
        subjectEighth: this.subjectName8 ? this.subjectName8['Course_Subject_name'] : this.withoutCodeSub8,
        marks_obt_Eighth: this.edu_form.controls.markEighthCtrl.value,
        marks_out_Eighth: this.edu_form.controls.markEighthOutCtrl.value,
        subjectNinth: this.subjectName9 ? this.subjectName9['Course_Subject_name'] : this.withoutCodeSub9,
        marks_obt_Ninth: this.edu_form.controls.markNinthCtrl.value,
        marks_out_Ninth: this.edu_form.controls.markNinthOutCtrl.value,
        subjectTenth: this.subjectName10 ? this.subjectName10['Course_Subject_name'] : this.withoutCodeSub10,
        marks_obt_Tenth: this.edu_form.controls.markTenthCtrl.value,
        marks_out_Tenth: this.edu_form.controls.markTenthOutCtrl.value,
        subjectElevanth: this.subjectName11 ? this.subjectName11['Course_Subject_name'] : this.withoutCodeSub11,
        marks_obt_Elevanth: this.edu_form.controls.markElevanthCtrl.value,
        marks_out_Elevanth: this.edu_form.controls.markElevanthOutCtrl.value,
        subjectTwelfth: this.subjectName12 ? this.subjectName12['Course_Subject_name'] : this.withoutCodeSub12,
        marks_obt_Twelfth: this.edu_form.controls.markTwelfthCtrl.value,
        marks_out_Twelfth: this.edu_form.controls.markTwelfthOutCtrl.value,
        user_id: this.user_id,
        medium_instruction: this.edu_form.controls.instructionCtrl.value,
        id: this.edu_id,
        lecture_hour_First: this.subjectName ? this.lec_per_week1 : this.edu_form.controls.lecturehourFirstCtrl.value,
        lecture_hour_Second: this.subjectName2 ? this.lec_per_week2 : this.edu_form.controls.lecturehourSecondCtrl.value,
        lecture_hour_Third: this.subjectName3 ? this.lec_per_week3 : this.edu_form.controls.lecturehourThirdCtrl.value,
        lecture_hour_Fourth: this.subjectName4 ? this.lec_per_week4 : this.edu_form.controls.lecturehourFourthCtrl.value,
        lecture_hour_Fifth: this.subjectName5 ? this.lec_per_week5 : this.edu_form.controls.lecturehourFifthCtrl.value,
        lecture_hour_Six: this.subjectName6 ? this.lec_per_week6 : this.edu_form.controls.lecturehourSixCtrl.value,
        lecture_hour_Seventh: this.subjectName7 ? this.lec_per_week7 : this.edu_form.controls.lecturehourSeventhCtrl.value,
        lecture_hour_Eighth: this.subjectName8 ? this.lec_per_week8 : this.edu_form.controls.lecturehourEighthCtrl.value,
        lecture_hour_Ninth: this.subjectName9 ? this.lec_per_week9 : this.edu_form.controls.lecturehourNinthCtrl.value,
        lecture_hour_Tenth: this.subjectName10 ? this.lec_per_week10 : this.edu_form.controls.lecturehourTenthCtrl.value,
        lecture_hour_Elevanth: this.subjectName10 ? this.lec_per_week10 : this.edu_form.controls.lecturehourElevanthCtrl.value,
        lecture_hour_Twelfth: this.subjectName10 ? this.lec_per_week10 : this.edu_form.controls.lecturehourTwelfthCtrl.value,
        practical_hour_First: this.subjectName ? this.prac_hour1 : this.edu_form.controls.practicalhourFirstCtrl.value,
        practical_hour_Second: this.subjectName2 ? this.prac_hour2 : this.edu_form.controls.practicalhourSecondCtrl.value,
        practical_hour_Third: this.subjectName3 ? this.prac_hour3 : this.edu_form.controls.practicalhourThirdCtrl.value,
        practical_hour_Fourth: this.subjectName4 ? this.prac_hour4 : this.edu_form.controls.practicalhourFourthCtrl.value,
        practical_hour_Fifth: this.subjectName5 ? this.prac_hour5 : this.edu_form.controls.practicalhourFifthCtrl.value,
        practical_hour_Six: this.subjectName6 ? this.prac_hour6 : this.edu_form.controls.practicalhourSixCtrl.value,
        practical_hour_Seventh: this.subjectName7 ? this.prac_hour7 : this.edu_form.controls.practicalhourSeventhCtrl.value,
        practical_hour_Eighth: this.subjectName8 ? this.prac_hour8 : this.edu_form.controls.practicalhourEighthCtrl.value,
        practical_hour_Ninth: this.subjectName9 ? this.prac_hour9 : this.edu_form.controls.practicalhourNinthCtrl.value,
        practical_hour_Tenth: this.subjectName10 ? this.prac_hour10 : this.edu_form.controls.practicalhourTenthCtrl.value,
        practical_hour_Elevanth: this.subjectName10 ? this.prac_hour10 : this.edu_form.controls.practicalhourElevanthCtrl.value,
        practical_hour_Twelfth: this.subjectName10 ? this.prac_hour10 : this.edu_form.controls.practicalhourTwelfthCtrl.value,

        total_weeks: this.edu_form.controls.totalweeksCtrl.value,
        special_instruction: this.edu_form.controls.specialInstrctionCtrl.value,
        grade_credits_Six: this.edu_form.controls.gradecreditsSixthCtrl.value,
        grade_credits_First: this.edu_form.controls.gradecreditsFirstCtrl.value,
        grade_credits_Second: this.edu_form.controls.gradecreditsSecondCtrl.value,
        grade_credits_Third: this.edu_form.controls.gradecreditsThirdCtrl.value,
        grade_credits_Fourth: this.edu_form.controls.gradecreditsFourthCtrl.value,
        grade_credits_Fifth: this.edu_form.controls.gradecreditsFifthCtrl.value,
        grade_credits_Seventh: this.edu_form.controls.gradecreditsSeventhCtrl.value,
        grade_credits_Eighth: this.edu_form.controls.gradecreditsEighthCtrl.value,
        grade_credits_Ninth: this.edu_form.controls.gradecreditsNinthCtrl.value,
        grade_credits_Elevanth: this.edu_form.controls.gradecreditsElevanthCtrl.value,
        grade_credits_Twelfth: this.edu_form.controls.gradecreditsTwelfthCtrl.value,

        course_code_one: this.subjectName ? this.subjectName['Course_Code'] : '',
        course_code_two: this.subjectName2 ? this.subjectName2['Course_Code'] : '',
        course_code_third: this.subjectName3 ? this.subjectName3['Course_Code'] : '',
        course_code_Fourth: this.subjectName4 ? this.subjectName4['Course_Code'] : '',
        course_code_Fifth: this.subjectName5 ? this.subjectName5['Course_Code'] : '',
        course_code_Six: this.subjectName6 ? this.subjectName6['Course_Code'] : '',
        course_code_Seventh: this.subjectName7 ? this.subjectName7['Course_Code'] : '',
        course_code_Eighth: this.subjectName8 ? this.subjectName8['Course_Code'] : '',
        course_code_Ninth: this.subjectName9 ? this.subjectName9['Course_Code'] : '',
        course_code_Tenth: this.subjectName10 ? this.subjectName10['Course_Code'] : '',
        course_code_Elevanth: this.subjectName11 ? this.subjectName11['Course_Code'] : '',
        course_code_Twelfth: this.subjectName12 ? this.subjectName12['Course_Code'] : '',
        externalOut_one: this.edu_form.controls.externalOutOfCtrl.value,
        internalOut_one: this.edu_form.controls.internalOutOfCtrl.value,
        totalOut_one: this.edu_form.controls.totalOutOfCtrl.value,
        externalOut_two: this.edu_form.controls.externalOut2OfCtrl.value,
        internalOut_two: this.edu_form.controls.internalOut2OfCtrl.value,
        totalOut_two: this.edu_form.controls.totalOut2OfCtrl.value,
        externalOut_third: this.edu_form.controls.externalOut3OfCtrl.value,
        internalOut_third: this.edu_form.controls.internalOut3OfCtrl.value,
        totalOut_third: this.edu_form.controls.totalOut3OfCtrl.value,
        externalOut_Fourth: this.edu_form.controls.externalOut4OfCtrl.value,
        internalOut_Fourth: this.edu_form.controls.internalOut4OfCtrl.value,
        totalOut_Fourth: this.edu_form.controls.totalOut4OfCtrl.value,
        externalOut_Fifth: this.edu_form.controls.externalOut5OfCtrl.value,
        internalOut_Fifth: this.edu_form.controls.internalOut5OfCtrl.value,
        totalOut_Fifth: this.edu_form.controls.totalOut5OfCtrl.value,
        externalOut_Six: this.edu_form.controls.externalOut6OfCtrl.value,
        internalOut_Six: this.edu_form.controls.internalOut6OfCtrl.value,
        totalOut_Six: this.edu_form.controls.totalOut6OfCtrl.value,
        externalOut_Seventh: this.edu_form.controls.externalOut7OfCtrl.value,
        internalOut_Seventh: this.edu_form.controls.internalOut7OfCtrl.value,
        totalOut_Seventh: this.edu_form.controls.totalOut7OfCtrl.value,
        externalOut_Eighth: this.edu_form.controls.externalOut8OfCtrl.value,
        internalOut_Eighth: this.edu_form.controls.internalOut8OfCtrl.value,
        totalOut_Eighth: this.edu_form.controls.totalOut8OfCtrl.value,
        externalOut_Ninth: this.edu_form.controls.externalOut9OfCtrl.value,
        internalOut_Ninth: this.edu_form.controls.internalOut9OfCtrl.value,
        totalOut_Ninth: this.edu_form.controls.totalOut9OfCtrl.value,
        externalOut_Tenth: this.edu_form.controls.externalOut10ofCtrl.value,
        internalOut_Tenth: this.edu_form.controls.internalOut10ofCtrl.value,
        totalOut_Tenth: this.edu_form.controls.totalOut10ofCtrl.value,
        externalOut_Elevanth: this.edu_form.controls.externalOut11ofCtrl.value,
        internalOut_Elevanth: this.edu_form.controls.internalOut11ofCtrl.value,
        totalOut_Elevanth: this.edu_form.controls.totalOut11ofCtrl.value,
        externalOut_Twelfth: this.edu_form.controls.externalOut12ofCtrl.value,
        internalOut_Twelfth: this.edu_form.controls.internalOut12ofCtrl.value,
        totalOut_Twelfth: this.edu_form.controls.totalOut12ofCtrl.value,

      }

      this.api.setEducationalValues(edu_data)
        .subscribe(
          (data: any) => {
            this.ref.close(data);
            err => console.error(err)
          });
    }
  }

  dismiss() {
    this.ref.close();
  }

  copyHoursValue() {

    if (this.edu_form.controls.practicalhourFirstCtrl.value) {
      if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectSeventhCtrl.value && this.edu_form.controls.subjectEighthCtrl.value) {
        this.hourValue = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue2 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue3 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue4 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue5 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue6 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue7 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue8 = this.edu_form.controls.practicalhourFirstCtrl.value;
      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectSeventhCtrl.value) {
        this.hourValue = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue2 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue3 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue4 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue5 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue6 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue7 = this.edu_form.controls.practicalhourFirstCtrl.value;
      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value) {
        this.hourValue = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue2 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue3 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue4 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue5 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue6 = this.edu_form.controls.practicalhourFirstCtrl.value;

      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value) {
        this.hourValue = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue2 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue3 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue4 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue5 = this.edu_form.controls.practicalhourFirstCtrl.value;

      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value) {
        this.hourValue = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue2 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue3 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue4 = this.edu_form.controls.practicalhourFirstCtrl.value;

      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value) {
        this.hourValue = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue2 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue3 = this.edu_form.controls.practicalhourFirstCtrl.value;


      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value) {
        this.hourValue = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue2 = this.edu_form.controls.practicalhourFirstCtrl.value;



      }


    }
  }

  copyLecValue() {
    if (this.edu_form.controls.lecturehourFirstCtrl.value) {
      if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectSeventhCtrl.value && this.edu_form.controls.subjectEighthCtrl.value) {
        this.lecVal1 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal2 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal3 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal4 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal5 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal6 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal7 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal8 = this.edu_form.controls.lecturehourFirstCtrl.value;
      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectSeventhCtrl.value) {
        this.lecVal1 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal2 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal3 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal4 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal5 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal6 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal7 = this.edu_form.controls.lecturehourFirstCtrl.value;

      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value) {
        this.lecVal1 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal2 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal3 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal4 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal5 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal6 = this.edu_form.controls.lecturehourFirstCtrl.value;


      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value) {
        this.lecVal1 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal2 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal3 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal4 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal5 = this.edu_form.controls.lecturehourFirstCtrl.value;

      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value) {
        this.lecVal1 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal2 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal3 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal4 = this.edu_form.controls.lecturehourFirstCtrl.value;


      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value) {
        this.lecVal1 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal2 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal3 = this.edu_form.controls.lecturehourFirstCtrl.value;

      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value) {
        this.lecVal1 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal2 = this.edu_form.controls.lecturehourFirstCtrl.value;


      }
    }
  }
  // addtion of  external marks and  internal marks
  getcXg() {
    this.totalMarks = 0
    if (this.edu_form.controls.markFirstCtrl.value && this.edu_form.controls.gradecreditsFirstCtrl.value) {
      this.getcxg1 = Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.gradecreditsFirstCtrl.value)
      if (this.getcxg1 > 0) {
        this.totalMarks = this.totalMarks + this.getcxg1;
      }
    }

    if (this.edu_form.controls.markSecondCtrl.value && this.edu_form.controls.gradecreditsSecondCtrl.value) {
      this.getcxg2 = Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.gradecreditsSecondCtrl.value)
      if (this.getcxg2 > 0) {
        this.totalMarks = this.totalMarks + this.getcxg2;
      }
    }

    if (this.edu_form.controls.markThirdCtrl.value && this.edu_form.controls.gradecreditsThirdCtrl.value) {
      this.getcxg3 = Number(this.edu_form.controls.markThirdCtrl.value) + Number(this.edu_form.controls.gradecreditsThirdCtrl.value)
      if (this.getcxg3 > 0) {
        this.totalMarks = this.totalMarks + this.getcxg3;
      }

    }

    if (this.edu_form.controls.markFourthCtrl.value && this.edu_form.controls.gradecreditsFourthCtrl.value) {
      this.getcxg4 = Number(this.edu_form.controls.markFourthCtrl.value) + Number(this.edu_form.controls.gradecreditsFourthCtrl.value)
      if (this.getcxg4 > 0) {
        this.totalMarks = this.totalMarks + this.getcxg4;
      }
    }

    if (this.edu_form.controls.markFifthCtrl.value && this.edu_form.controls.gradecreditsFifthCtrl.value) {
      this.getcxg5 = Number(this.edu_form.controls.markFifthCtrl.value) + Number(this.edu_form.controls.gradecreditsFifthCtrl.value)
      if (this.getcxg5 > 0) {
        this.totalMarks = this.totalMarks + this.getcxg5;
      }
    }

    if (this.edu_form.controls.markSixthCtrl.value && this.edu_form.controls.gradecreditsSixthCtrl.value) {
      this.getcxg6 = Number(this.edu_form.controls.markSixthCtrl.value) + Number(this.edu_form.controls.gradecreditsSixthCtrl.value)
      if (this.getcxg6 > 0) {
        this.totalMarks = this.totalMarks + this.getcxg6;
      }
    }

    if (this.edu_form.controls.markSeventhCtrl.value && this.edu_form.controls.gradecreditsSeventhCtrl.value) {
      this.getcxg7 = Number(this.edu_form.controls.markSeventhCtrl.value) + Number(this.edu_form.controls.gradecreditsSeventhCtrl.value)
      if (this.getcxg7 > 0) {
        this.totalMarks = this.totalMarks + this.getcxg7;

      }
    }

    if (this.edu_form.controls.markEighthCtrl.value && this.edu_form.controls.gradecreditsEighthCtrl.value) {
      this.getcxg8 = Number(this.edu_form.controls.markEighthCtrl.value) + Number(this.edu_form.controls.gradecreditsEighthCtrl.value)
      if (this.getcxg8 > 0) {
        this.totalMarks = this.totalMarks + this.getcxg8;

      }
    }
    if (this.edu_form.controls.markNinthCtrl.value && this.edu_form.controls.gradecreditsNinthCtrl.value) {
      this.getcxg9 = Number(this.edu_form.controls.markNinthCtrl.value) + Number(this.edu_form.controls.gradecreditsNinthCtrl.value)
      if (this.getcxg9 > 0) {
        this.totalMarks = this.totalMarks + this.getcxg9;

      }
    }
    if (this.edu_form.controls.markTenthCtrl.value && this.edu_form.controls.gradecreditsTenthCtrl.value) {
      this.getcxg10 = Number(this.edu_form.controls.markTenthCtrl.value) + Number(this.edu_form.controls.gradecreditsTenthCtrl.value)
      if (this.getcxg10 > 0) {
        this.totalMarks = this.totalMarks + this.getcxg10;

      }
    }
    if (this.edu_form.controls.markElevanthCtrl.value && this.edu_form.controls.gradecreditsElevanthCtrl.value) {
      this.getcxg11 = Number(this.edu_form.controls.markElevanthCtrl.value) + Number(this.edu_form.controls.gradecreditsElevanthCtrl.value)
      if (this.getcxg11 > 0) {
        this.totalMarks = this.totalMarks + this.getcxg11;

      }
    }
    if (this.edu_form.controls.markTwelfthCtrl.value && this.edu_form.controls.gradecreditsTwelfthCtrl.value) {
      this.getcxg12 = Number(this.edu_form.controls.markTwelfthCtrl.value) + Number(this.edu_form.controls.gradecreditsTwelfthCtrl.value)
      if (this.getcxg12 > 0) {
        this.totalMarks = this.totalMarks + this.getcxg12;

      }
    }

  }

  //  addtion of out of external marks and out of internal marks
  getoutoff() {
    this.totalMarksOut = 0
    if (this.edu_form.controls.externalOutOfCtrl.value && this.edu_form.controls.internalOutOfCtrl.value) {
      this.getoutoff1 = Number(this.edu_form.controls.externalOutOfCtrl.value) + Number(this.edu_form.controls.internalOutOfCtrl.value)
      if (this.getoutoff1 > 0) {
        this.totalMarksOut = this.totalMarksOut + this.getoutoff1;
      }
    }
    if (this.edu_form.controls.externalOut2OfCtrl.value && this.edu_form.controls.internalOut2OfCtrl.value) {
      this.getoutoff2 = Number(this.edu_form.controls.externalOut2OfCtrl.value) + Number(this.edu_form.controls.internalOut2OfCtrl.value)
      if (this.getoutoff1 > 0) {
        this.totalMarksOut = this.totalMarksOut + this.getoutoff2;
      }
    }
    if (this.edu_form.controls.externalOut3OfCtrl.value && this.edu_form.controls.internalOut3OfCtrl.value) {
      this.getoutoff3 = Number(this.edu_form.controls.externalOut3OfCtrl.value) + Number(this.edu_form.controls.internalOut3OfCtrl.value)
      if (this.getoutoff3 > 0) {
        this.totalMarksOut = this.totalMarksOut + this.getoutoff3;
      }
    }
    if (this.edu_form.controls.externalOut4OfCtrl.value && this.edu_form.controls.internalOut4OfCtrl.value) {
      this.getoutoff4 = Number(this.edu_form.controls.externalOut4OfCtrl.value) + Number(this.edu_form.controls.internalOut4OfCtrl.value)
      if (this.getoutoff4 > 0) {
        this.totalMarksOut = this.totalMarksOut + this.getoutoff4;
      }
    }
    if (this.edu_form.controls.externalOut5OfCtrl.value && this.edu_form.controls.internalOut5OfCtrl.value) {
      this.getoutoff5 = Number(this.edu_form.controls.externalOut5OfCtrl.value) + Number(this.edu_form.controls.internalOut5OfCtrl.value)
      if (this.getoutoff5 > 0) {
        this.totalMarksOut = this.totalMarksOut + this.getoutoff5;
      }
    }
    if (this.edu_form.controls.externalOut6OfCtrl.value && this.edu_form.controls.internalOut6OfCtrl.value) {
      this.getoutoff6 = Number(this.edu_form.controls.externalOut6OfCtrl.value) + Number(this.edu_form.controls.internalOut6OfCtrl.value)
      if (this.getoutoff6 > 0) {
        this.totalMarksOut = this.totalMarksOut + this.getoutoff6;
      }
    }
    if (this.edu_form.controls.externalOut7OfCtrl.value && this.edu_form.controls.internalOut7OfCtrl.value) {
      this.getoutoff7 = Number(this.edu_form.controls.externalOut7OfCtrl.value) + Number(this.edu_form.controls.internalOut7OfCtrl.value)
      if (this.getoutoff7 > 0) {
        this.totalMarksOut = this.totalMarksOut + this.getoutoff7;
      }
    }
    if (this.edu_form.controls.externalOut8OfCtrl.value && this.edu_form.controls.internalOut8OfCtrl.value) {
      this.getoutoff8 = Number(this.edu_form.controls.externalOut8OfCtrl.value) + Number(this.edu_form.controls.internalOut8OfCtrl.value)
      if (this.getoutoff8 > 0) {
        this.totalMarksOut = this.totalMarksOut + this.getoutoff8;
      }
    }
    if (this.edu_form.controls.externalOut9OfCtrl.value && this.edu_form.controls.internalOut9OfCtrl.value) {
      this.getoutoff9 = Number(this.edu_form.controls.externalOut9OfCtrl.value) + Number(this.edu_form.controls.internalOut9OfCtrl.value)
      if (this.getoutoff9 > 0) {
        this.totalMarksOut = this.totalMarksOut + this.getoutoff9;
      }
    }
    if (this.edu_form.controls.externalOut10ofCtrl.value && this.edu_form.controls.internalOut10ofCtrl.value) {
      this.getoutoff10 = Number(this.edu_form.controls.externalOut10ofCtrl.value) + Number(this.edu_form.controls.internalOut10ofCtrl.value)
      if (this.getoutoff10 > 0) {
        this.totalMarksOut = this.totalMarksOut + this.getoutoff10;
      }
    }
    if (this.edu_form.controls.externalOut11ofCtrl.value && this.edu_form.controls.internalOut11ofCtrl.value) {
      this.getoutoff11 = Number(this.edu_form.controls.externalOut11ofCtrl.value) + Number(this.edu_form.controls.internalOut11ofCtrl.value)
      if (this.getoutoff11 > 0) {
        this.totalMarksOut = this.totalMarksOut + this.getoutoff11;
      }
    }
    if (this.edu_form.controls.externalOut12ofCtrl.value && this.edu_form.controls.internalOut12ofCtrl.value) {
      this.getoutoff12 = Number(this.edu_form.controls.externalOut12ofCtrl.value) + Number(this.edu_form.controls.internalOut12ofCtrl.value)
      if (this.getoutoff12 > 0) {
        this.totalMarksOut = this.totalMarksOut + this.getoutoff12;
      }
    }
  }

  onDeleteSubject(no) {
    this.api.deleteRecords(this.user_id, this.edu_id, no)
      .subscribe(data => {
        if (data["status"] == 200) {
          this.ngOnInit();
          this.toasterService.success("Deleted successfully");
        }
      },
        (err) => console.error(err)
      );
  }

  showcoursecodeDropdown() {
    this.showcodeDropdown1 = true
  }

  showcoursecodeDropdown2() {
    this.showcodeDropdown2 = true
  }

  showcoursecodeDropdown3() {
    this.showcodeDropdown3 = true
  }

  showcoursecodeDropdown4() {
    this.showcodeDropdown4 = true
  }

  showcoursecodeDropdown5() {
    this.showcodeDropdown5 = true
  }

  showcoursecodeDropdown6() {
    this.showcodeDropdown6 = true
  }

  showcoursecodeDropdown7() {
    this.showcodeDropdown7 = true
  }

  showcoursecodeDropdown8() {
    this.showcodeDropdown8 = true
  }

  showcoursecodeDropdown9() {
    this.showcodeDropdown9 = true
  }
  showcoursecodeDropdown10() {
    this.showcodeDropdown10 = true
  }
  showcoursecodeDropdown11() {
    this.showcodeDropdown11 = true
  }
  showcoursecodeDropdown12() {
    this.showcodeDropdown12 = true
  }


  showContactDetails() {
    this.confirmationService.confirm({
      message: 'Email - stxaviers@etranscript.in &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;  &nbsp;' + ' Whatsapp - +91 99306 00066',
      header: 'Please contact the admin on ',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {

      },
      reject: () => {

      }
    });
  }

}